// apps/dashboard/src/lib/prefs-storage.ts
import Cookies from 'js-cookie';
import { clientCookieAttributes } from './cookies';

export const PREFS_COOKIE = 'aks_prefs';
export const PREFS_COOKIE_MAX_AGE_DAYS = 180;

export type AudienceSegment = 'SISWA' | 'MAHASISWA' | 'UMUM';

export interface PreferencesState {
  segment: AudienceSegment | null;
  interests: string[]; // ExamType slugs, multi-select
}

export const EMPTY_PREFERENCES: PreferencesState = { segment: null, interests: [] };

/**
 * Legacy scalar `interest` (still written by any not-yet-migrated consumer)
 * normalizes to a single-element array; missing/null normalizes to empty.
 */
export function normalizeInterests(parsed: unknown): string[] {
  const obj = parsed as { interests?: unknown; interest?: unknown } | null | undefined;
  if (Array.isArray(obj?.interests)) return obj.interests as string[];
  if (typeof obj?.interest === 'string' && obj.interest) return [obj.interest];
  return [];
}

export function loadPreferencesFromCookie(): PreferencesState {
  const raw = Cookies.get(PREFS_COOKIE);
  if (!raw) return EMPTY_PREFERENCES;
  try {
    const parsed = JSON.parse(raw);
    return {
      segment: parsed?.segment ?? null,
      interests: normalizeInterests(parsed),
    };
  } catch {
    return EMPTY_PREFERENCES;
  }
}

export function savePreferencesToCookie(prefs: PreferencesState): void {
  Cookies.set(
    PREFS_COOKIE,
    JSON.stringify({
      segment: prefs.segment,
      interests: prefs.interests,
      // Mirror field for any consumer still reading the legacy scalar.
      interest: prefs.interests[0] ?? null,
    }),
    clientCookieAttributes(PREFS_COOKIE_MAX_AGE_DAYS),
  );
}
